import { render, staticRenderFns } from "./Rewardamount.vue?vue&type=template&id=6be12bb5"
import script from "./Rewardamount.vue?vue&type=script&lang=js"
export * from "./Rewardamount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports